class ModeSwitcher {
  constructor(callback, identifier, childIdentifier) {
    this.callback = callback
    if (identifier == null) {
      identifier = '.js-view-modes'
    }
    this.identifier = identifier
    if (childIdentifier == null) {
      childIdentifier = '.js-view-mode-item'
    }
    this.childIdentifier = childIdentifier
    const menu = $(this.identifier)
    if (menu.length > 0) {
      menu.children(this.childIdentifier).on('click', e => {
        this.callback($(e.target).data('mode'))
        menu.children(this.childIdentifier).removeClass('active')
        const newMenuItem = $(e.target)
        return newMenuItem.addClass('active')
      })
    }
  }
}

export default ModeSwitcher
